/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CameraChannelsAll } from './CameraChannelsAll';
import type { VehicleScheduleBase } from './VehicleScheduleBase';
export type VehicleScheduleCameraDownload = (VehicleScheduleBase & {
    config?: {
        channel: CameraChannelsAll;
        /**
         * Additional notification recipients besides the schedule owner
         */
        emails?: Array<string>;
    };
    /**
     * 0=Sun, 6=Sat (holidays not allowed)
     */
    day_of_week?: number;
    type?: VehicleScheduleCameraDownload.type;
});
export namespace VehicleScheduleCameraDownload {
    export enum type {
        CAMERA_DOWNLOAD = 'camera-download',
    }
}

